









import {Component, Prop, Vue} from "vue-property-decorator";
import {ACTIVE_SHIPMENT_TYPE} from "@/constants/orders";
import {ShipmentLogic} from "@/models/ShipmentLogic";
import {IActiveShipment} from "@/models/StoreModels";
import DataPair from "@/views/components/PairData/DataPair.vue";
import VueI18n from "vue-i18n";
import LocaleMessage = VueI18n.LocaleMessage;
import {namespace} from "vuex-class";

const userDataModule = namespace('userData');


@Component({
  name: "ShipmentTypeDataPair",
  components: {
    DataPair,
  },
})
export default class ShipmentTypeDataPair extends Vue {
  @userDataModule.Getter('getId')
  private userId!: number;

  @Prop()
  private shipment!: IActiveShipment;

  private get readableType(): LocaleMessage {
    switch (this.shipment.type) {
      case ACTIVE_SHIPMENT_TYPE.TYPE_CROSSTOWN_DELIVERY:
        return ShipmentLogic.userIsCrosstownSender(this.shipment, this.userId) ? this.$t('types.crosstownSender')
            : this.$t('types.crosstownRecipient');
      case ACTIVE_SHIPMENT_TYPE.TYPE_EXTERNAL_INCOMING:
        return this.$t('types.external');
      case ACTIVE_SHIPMENT_TYPE.TYPE_CLICK_COLLECT_INCOMING:
        return this.$t('types.clickCollect');
      case ACTIVE_SHIPMENT_TYPE.TYPE_AMAZON_RETURNS_DELIVERY:
        return this.$t('types.returns');
      case ACTIVE_SHIPMENT_TYPE.TYPE_PUBLIC_DELIVERY:
        return this.$t('types.publicDelivery');
      default:
        return this.$t('types.error');
    }
  }
}

